import { render } from "./ObjectDelete.vue?vue&type=template&id=596b64ba"
import script from "./ObjectDelete.vue?vue&type=script&lang=js"
export * from "./ObjectDelete.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/aft/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__